module.exports = __webpack_public_path__ + "img/pic_app_easy.2e0ca500.jpg";